import * as lang from './lang'

function isCurrentUser() {
    const currentUser = localStorage.token
    if (currentUser) {
        return true;
    } 
    return false;
}
function isLocalStorage() {
    const current = window.localStorage;
    if (current) {
        return true;
    }
    return false;
}
function isLang(_json) {
    let _lang = "en";
    let _langId = 0;
    const _navlang = window.navigator.language.slice(0, 2);
    for(var i=0;i<_json.length;i++){
        if(_json[i]['lang']==_navlang){
            _lang = _navlang
            _langId = i
            break;
        }
    }

    localStorage.lang = _lang
    localStorage.langId = _langId
    const current = localStorage.lang
    if (current) {
        return true;
    }
    return false;
}
function parseParam(param) {
    var paramStr="";
    for (var key in param) {
        if(param[key]!=''&&param[key]!=null){
            paramStr += '&'+key+'='+param[key];
        }
    }
    return paramStr.substr(1);
}
function swiper(_type = ''){
    return {
        direction: _type,//vertical
        slidesPerView: 'auto',
        freeMode: true,
        mousewheel: true
    }
}
function chooseLang(){
    return localStorage.lang?localStorage.lang:'en'
  }
function swiperTouch(){
    return {
        name: 'topSwiper',
        slidesPerView: 'auto',
        spaceBetween: 15,
        touchMoveStopPropagation:false,
        pagination: {
            el: ".case-banner .banner-page",
            type: "fraction",
          }
        // loop: true,
        // autoplay:true
        // freeMode: true,
        // mousewheel: true
    }
}
function swiperTranslate(_this,_num){
    _this.swiper.setTranslate(_num);
}
Date.prototype.Format = function (fmt) {
    var o = {
        "M+": this.getMonth() + 1,                 //月份
        "d+": this.getDate(),                    //日
        "h+": this.getHours(),                   //小时
        "m+": this.getMinutes(),                 //分
        "s+": this.getSeconds(),                 //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds()             //毫秒
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}
function format(times = '', pattern = 'yyyy/MM/dd hh:mm:ss') {
    let _time
    if(times){
        _time = new Date(times).Format(pattern);
    }else{
        _time = new Date().Format(pattern);
    }
    return _time.toLocaleString();
}
function getUrlKey(name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
}
function getLang(){
    let _lang = ["af", "sq", "ar-SA", "ar-IQ", "ar-EG", "ar-LY", "ar-DZ", "ar-MA", "ar-TN", "ar-OM", 
    "ar-YE", "ar-SY", "ar-JO", "ar-LB", "ar-KW", "ar-AE", "ar-BH", "ar-QA", "eu", "bg", 
    "be", "ca", "zh-TW", "zh-CN", "zh-HK", "zh-SG", "hr", "cs", "da", "nl", "nl-BE", "en", 
    "en-US", "en-EG", "en-AU", "en-GB", "en-CA", "en-NZ", "en-IE", "en-ZA", "en-JM", 
    "en-BZ", "en-TT", "et", "fo", "fa", "fi", "fr", "fr-BE", "fr-CA", "fr-CH", "fr-LU", 
    "gd", "gd-IE", "de", "de-CH", "de-AT", "de-LU", "de-LI", "el", "he", "hi", "hu", 
    "is", "id", "it", "it-CH", "ja", "ko", "lv", "lt", "mk", "mt", "no", "pl", 
    "pt-BR", "pt", "rm", "ro", "ro-MO", "ru", "ru-MI", "sz", "sr", "sk", "sl", "sb", 
    "es", "es-AR", "es-GT", "es-CR", "es-PA", "es-DO", "es-MX", "es-VE", "es-CO", 
    "es-PE", "es-EC", "es-CL", "es-UY", "es-PY", "es-BO", "es-SV", "es-HN", "es-NI", 
    "es-PR", "sx", "sv", "sv-FI", "th", "ts", "tn", "tr", "uk", "ur", "ve", "vi", "xh", 
    "ji", "zu"];
}
function getHouse(_id,empty=false){
    if(!localStorage.appInit || _id==0){
        if(!empty){
            return '-';
        }else{
            return '';
        }
    }
    const appInit = JSON.parse(localStorage.appInit)
    const json = appInit.style_house
    let _name = ''
    for (let index = 0; index < json.length; index++) {
        if(json[index]['id'] == _id){
            _name = json[index]['title']
            break;
        }
    }
    return _name;
}
function getScene(_id){
    if(!localStorage.appInit || _id==0){
        return '-';
    }
    const appInit = JSON.parse(localStorage.appInit)
    const json = appInit.style_scene
    let _name = ''
    for (let index = 0; index < json.length; index++) {
        if(json[index]['id'] == _id){
            _name = json[index]['title']
            break;
        }
    }
    return _name;
}
function getStyle(_id){
    if(!localStorage.appInit || _id == null || _id.length<=0){
        return [];
    }
    const appInit = JSON.parse(localStorage.appInit)
    const json = appInit.style_category
    let _name = []
    for (let i = 0; i < _id.length; i++) {
        for (let index = 0; index < json.length; index++) {
            if(json[index]['id'] == _id[i]){
                _name.push(json[index]['title'])
                break;
            }
        }
    }
    return _name;
}
function getSpace(_id){
    if(!localStorage.appInit || _id == null || _id.length<=0){
        return [];
    }
    const appInit = JSON.parse(localStorage.appInit)
    const json = appInit.style_space
    let _name = []
    for (let i = 0; i < _id.length; i++) {
        for (let index = 0; index < json.length; index++) {
            if(json[index]['id'] == _id[i]){
                _name.push(json[index]['title'])
                break;
            }
        }
    }
    return _name;
}
function getServer(_id){
    if(!localStorage.appInit || _id == null || _id.length<=0){
        return [];
    }
    const appInit = JSON.parse(localStorage.appInit)
    const json = appInit.style_server
    let _name = []
    for (let i = 0; i < _id.length; i++) {
        for (let index = 0; index < json.length; index++) {
            if(json[index]['id'] == _id[i]){
                _name.push(json[index]['title'])
                break;
            }
        }
    }
    return _name;
}
function getServerco(_id){
    if(!localStorage.appInit || _id == null || _id.length<=0){
        return [];
    }
    const appInit = JSON.parse(localStorage.appInit)
    const json = appInit.style_serverco
    let _name = []
    for (let i = 0; i < _id.length; i++) {
        for (let index = 0; index < json.length; index++) {
            if(json[index]['id'] == _id[i]){
                _name.push(json[index]['title'])
                break;
            }
        }
    }
    return _name;
}
function getWork(_id){
    if(!localStorage.appInit || _id == null || _id.length<=0){
        return [];
    }
    const appInit = JSON.parse(localStorage.appInit)
    const json = appInit.style_work
    let _name = []
    for (let i = 0; i < _id.length; i++) {
        for (let index = 0; index < json.length; index++) {
            if(json[index]['id'] == _id[i]){
                _name.push(json[index]['title'])
                break;
            }
        }
    }
    return _name;
}
function getBegoodca(_id,empty=false){
    if(!localStorage.appInit || _id == null || _id.length<=0){
        if(!empty){
            return [];
        }else{
            return '';
        }
    }
    const appInit = JSON.parse(localStorage.appInit)
    const json = appInit.style_begoodca
    let _name = []
    for (let i = 0; i < _id.length; i++) {
        for (let index = 0; index < json.length; index++) {
            if(json[index]['id'] == _id[i]){
                _name.push(json[index]['title'])
                break;
            }
        }
    }
    return _name;
}
function getType(_id){
    if(!localStorage.appInit || _id == null || _id.length<=0){
        return [];
    }
    const appInit = JSON.parse(localStorage.appInit)
    const json = appInit.style_type
    let _name = []
    for (let i = 0; i < _id.length; i++) {
        for (let index = 0; index < json.length; index++) {
            if(json[index]['id'] == _id[i]){
                _name.push(json[index]['title'])
                break;
            }
        }
    }
    return _name;
}

export {
    isLocalStorage,
    isCurrentUser,
    parseParam,
    swiper,
    swiperTouch,
    format,
    getUrlKey,
    isLang,
    chooseLang,
    swiperTranslate,
    getLang,
    getHouse,
    getScene,
    getStyle,
    getSpace,
    getServer,
    getBegoodca,
    getType,
    getWork,
    getServerco
}



// WEBPACK FOOTER //
// ./src/assets/js/util.js